import * as React from 'react';
import * as R from 'ramda';
import { withIntl, IntlProps } from 'ha/i18n';
import getScriptJs from 'ha/helpers/scriptjsWrapper';
import { getDefaultTheme } from '../utils';

let globalId = 0;

interface OwnProps {
  portalId: string;
  formId: string;
  submitText?: string;
  track: (eventName: string, params: {}) => void;
  css?: string;
  kind?: 'default' | 'hubspot';
}

type Props = OwnProps & IntlProps;

interface State {
  id?: number;
}

const HUBSPOT_FORM_SCRIPT_SRC = '//js.hsforms.net/forms/v2.js';

class HubspotForm extends React.Component<Props, State> {
  containerRef: React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  loadScript() {
    return getScriptJs(HUBSPOT_FORM_SCRIPT_SRC);
  }

  componentDidMount() {
    this.setState(
      {
        id: globalId++,
      },
      () => {
        this.loadScript().then(this.handleScriptLoad);
      },
    );
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.formId === this.props.formId &&
      prevProps.portalId === this.props.portalId
    ) {
      return;
    }

    this.loadScript().then(this.handleScriptLoad);
  }

  componentWillUnmount() {
    if (this.containerRef.current) {
      this.containerRef.current.removeEventListener(
        'hsvalidatedsubmit',
        this.handleSubmitSuccess,
      );
    }
  }

  handleSubmitSuccess = (e: Event) => {
    if (!this.containerRef.current) {
      return;
    }
    const emailInput: HTMLInputElement | null = this.containerRef.current.querySelector(
      '[name=email]',
    );
    if (!emailInput) {
      return;
    }
    this.props.track('Lead form submitted', {
      email: emailInput.value,
      formId: this.props.formId,
      portalId: this.props.portalId,
    });
  };

  handleScriptLoad = () => {
    // according to the list of locales here chinese should use zh-ch
    // https://developers.hubspot.com/docs/methods/forms/advanced_form_options
    const {
      kind = 'default',
      css,
      intl: { T, locale },
      portalId,
      formId,
      submitText,
    } = this.props;

    const theme = kind === 'default' ? getDefaultTheme(css) : {};

    // tslint:disable-next-line no-any
    (global as any).hbspt.forms.create({
      portalId,
      formId,
      formInstanceId: this.state.id,
      target: `#hubspot-form-container-${this.state.id}`,
      locale,
      ...theme,
      translations: {
        [locale]: {
          submitText: submitText || T('Submit'),
          fieldLabels: {
            email: T('Email'),
            firstName: T('First name'),
            firstname: T('First name'), // Not sure why it camel case above, in hubspot we have this one 🤔
            phone: T('Phone number'),
            city: T('hubspot_form_input_city'),
            checkbox_subscription: T('hubspot_form_checkbox_subscription'),
          },
        },
      },
    });

    if (this.containerRef.current) {
      this.containerRef.current.addEventListener(
        'hsvalidatedsubmit',
        this.handleSubmitSuccess,
      );
    }
  };

  render() {
    return !R.isNil(this.state.id) ? (
      <div
        ref={this.containerRef}
        id={`hubspot-form-container-${this.state.id}`}
      />
    ) : null;
  }
}

export default withIntl(HubspotForm);
